import React from "react";
import { Modal, Table, Tag,  Empty } from "antd";

function ViewModal({ isModalVisible, handleCancel, initialValues }) {
  // Plan features data from props
  const planFeatures = initialValues?.plan_features || [];

  // Columns for the plan_features table (CreditSubscriptionPlanFeatures shape)
  const columns = [
    {
      title: "Feature",
      dataIndex: "feature_slug",
      key: "feature_slug",
    },
    {
      title: "Credit Value",
      dataIndex: "credit_value",
      key: "credit_value",
    },
    {
      title: "Reset Policy",
      dataIndex: "reset_policy",
      key: "reset_policy",
      render: (text) => (text ? text.replace(/_/g, " ") : "-"),
    },
    {
      title: "Active",
      dataIndex: "is_active",
      key: "is_active",
      render: (is_active) => (
        <Tag color={is_active ? "green" : "red"}>
          {is_active ? "Active" : "Inactive"}
        </Tag>
      ),
    },
  ];

  return (
    <Modal
      title="View Feature Details"
      open={isModalVisible}
      footer={null}
      onCancel={handleCancel}
      width={700}
    >
      {initialValues ? (
        <>
          {/* Plan details section */}
          {/* <Descriptions
            bordered
            size="small"
            column={1}
            style={{ marginBottom: 20 }}
          >
            <Descriptions.Item label="Plan Name">
              {initialValues.name}
            </Descriptions.Item>
            <Descriptions.Item label="Monthly Cost">
              ${initialValues.monthly_cost}
            </Descriptions.Item>
            <Descriptions.Item label="Yearly Cost">
              ${initialValues.yearly_cost}
            </Descriptions.Item>
            <Descriptions.Item label="Status">
              <Tag color={initialValues.is_enable ? "green" : "red"}>
                {initialValues.is_enable ? "Enabled" : "Disabled"}
              </Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Default Plan">
              <Tag color={initialValues.is_default_plan ? "green" : "red"}>
                {initialValues.is_default_plan ? "Yes" : "No"}
              </Tag>
            </Descriptions.Item>
          </Descriptions> */}

          {/* Plan features table */}
          {planFeatures.length > 0 ? (
            <Table
              columns={columns}
              dataSource={planFeatures}
              rowKey="id"
              pagination={false}
              size="small"
            />
          ) : (
            <Empty description="No features available" />
          )}
        </>
      ) : (
        <Empty description="No plan selected" />
      )}
    </Modal>
  );
}

export default ViewModal;
